/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
const INITIAL_CONTEXT = {
  idle: {},
  ADD_CREDIT_UNION: {},
};

const MACHINE_CONFIG = {
  id: 'io.vlinder.klefki.add.credit.union',
  initial: 'idle',
  context: INITIAL_CONTEXT,
  states: {
    idle: {
      entry: ['resetAction'],
      on: {
        START: { target: 'ADD_CREDIT_UNION' },
      },
    },
    ADD_CREDIT_UNION: {
      invoke: {
        id: 'addGroup',
        src: 'addGroup',
        onDone: {
          target: 'ADD_CREDIT_UNION_SUCCESS',
          actions: ['successAction'],
        },
        onError: {
          target: 'ADD_CREDIT_UNION_FAILED',
          actions: ['failureAction'],
        },
      },
    },
    ADD_CREDIT_UNION_SUCCESS: {
      type: 'final',
    },
    ADD_CREDIT_UNION_FAILED: {
      type: 'final',
    },
  },
};

//Machine(MACHINE_CONFIG)

export { INITIAL_CONTEXT, MACHINE_CONFIG };
